import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import useAxios from "../../../../../MainComponents/Hooks/useAxios";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const UnlockHoldCoursesForm = ({ courseId, studentId }) => {
  const [formValues, setFormValues] = useState({});
  const [formFlag, setFormFlag] = useState();
  const [formDependency, setFormDependency] = useState(false);

  const { handleSubmit } = useForm({ mode: "onTouched" });

  const [
    unlockHoldCoursesSucsses,
    unlockHoldCoursesErrors,
    unlockHoldCoursesLoading,
  ] = useAxios(
    process.env.REACT_APP_ADMIN_COURSE_UNLOCK_HOLD_API,
    "POST",
    formFlag,
    formDependency,
    formValues,
    true
  );

  const onSubmit = () => {
    setFormValues({ course_id: courseId, student_id: studentId });
    setFormFlag("unlockHoldCourse");
    setFormDependency(true);
  };

  useEffect(() => {
    if (unlockHoldCoursesSucsses) {
      setFormFlag("");
      setFormDependency(false);
    }
  }, [unlockHoldCoursesSucsses]);

  useEffect(() => {
    if (unlockHoldCoursesErrors) {
      setFormFlag("");
      setFormDependency(false);
    }
  }, [unlockHoldCoursesErrors]);
  return (
    <form
      encType="multipart/form-data"
      method="post"
      onSubmit={handleSubmit(onSubmit)}
      className="w-full"
    >
      <button className=" submit mt-6 w-full" type="submit">
        {unlockHoldCoursesLoading ? (
          <FontAwesomeIcon icon={faSpinner} spin />
        ) : (
          " Unlock Hold Course "
        )}
      </button>
    </form>
  );
};

export default UnlockHoldCoursesForm;
